/**
 * * Элемент списка статуса для обновления статусов очереди
 */
export default class UpdateQueueTaskStatusRequestItem  {
	/**
	 * * Номер статуса
	 */
	StatusId?: number;
	/**
	 * * Цвет статуса
	 */
	Color!: string;
	/**
	 * * Название статуса
	 */
	Name!: string;
	/**
	 * * Описание
	 */
	Description!: string;
	/**
	 * * Выставлен по умолчанию
	 */
	IsDefault: boolean = false;
	/**
	 * * Порядковый номер
	 */
	Number!: number;
	/**
	 * * Статус организации
	 */
	OrganizationStatusId?: string;
	/**
	 * * Номер статуса рабочей области
	 */
	NamespaceStatusId?: string;
	constructor(obj?: Partial<UpdateQueueTaskStatusRequestItem>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
